// target blank script
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// START VIDEO
function avadaVideo(btn, playpause, sound) {
  if (!btn) return;
  const videoWrapper = btn.closest('.section-avada-video');
    if (!videoWrapper) return;
  const video = videoWrapper.querySelector('video');
    if (!video) return;
  
  if(playpause) video.paused ? video.play() : video.pause();
    if(sound) video.muted = !video.muted;
  btn.classList.toggle("active");
}

// 
